var _defs, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionsPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 66.14 61.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebeffd;}.cls-2{fill:#ff6e14;}.cls-3{fill:#d0dbfb;}.cls-4{fill:#948dbd;}.cls-5{fill:#544993;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m44.94,22.19v-12.9c0-.89-.72-1.61-1.61-1.61h-12.73v14.51h14.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.77,7.67h-2.54c-.89,0-1.61.72-1.61,1.61v12.9h4.15V7.67Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.77,
    y: 7.67,
    width: 3.83,
    height: 14.51
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m44.94,22.19v21.06c0,.89-.72,1.61-1.61,1.61h-19.11c-.89,0-1.61-.72-1.61-1.61v-21.06h-7.04v25.07l18.21,6.17,18.21-6.17v-25.07h-7.04Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.23,44.85h2.54v-22.67h-4.15v21.06c0,.89.72,1.61,1.61,1.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.6,44.85h12.73c.89,0,1.61-.72,1.61-1.61v-21.06h-14.34v22.67Zm4.04-15.68v13.4h-1.71v-13.4h1.71Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.77,
    y: 22.19,
    width: 3.83,
    height: 22.67
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.92,
    y: 29.17,
    width: 1.71,
    height: 13.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.57,
    y: 22.19,
    width: 36.42,
    height: 2.26
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsPayments);
export default __webpack_public_path__ + "static/media/Solutions_Payments.52c96e6a9beb99276391352bc7c1a5d3.svg";
export { ForwardRef as ReactComponent };